import StyleWrapper from 'publisher/components/core/StyleWrapper'
import usePage, { selectors } from 'publisher/hooks/usePage'
import { useWebsiteSettings } from 'publisher/store'
import React, { useEffect, useState } from 'react'
import {
  getDefaultWebsiteLocale,
  getWebsiteLocales,
} from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonWebsiteLanguageSwitcher } from 'src/shared/entities/website-language-switcher'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'

export interface WebsiteLanguageSwitcherProps {
  entity: WebsiteLanguageSwitcherInterface
}

export const WebsiteLanguageSwitcher = ({
  entity,
}: WebsiteLanguageSwitcherProps) => {
  const [isClient, setIsClient] = useState(false)
  const locale = usePage(selectors.getLocale)
  const websiteLocales = useWebsiteSettings(getWebsiteLocales)
  const websiteDefaultLocale = useWebsiteSettings(getDefaultWebsiteLocale)
  useEffect(() => {
    setIsClient(true)
  })
  return (
    isClient && (
      <StyleWrapper
        margin={entity.margin}
        mobileMargin={entity.mobileMargin}
        appearance={entity.appearance}
      >
        <CommonWebsiteLanguageSwitcher
          websiteLocales={websiteLocales}
          websiteDefaultLocale={websiteDefaultLocale}
          currentLanguage={locale}
          {...entity}
        />
      </StyleWrapper>
    )
  )
}
